import type { Language } from './language';

/** The ҚАЗ / РУС pill labels. Each language names itself, so neither is translated. */
export const LANGUAGE_SHORT_LABELS: Record<Language, string> = { kk: 'ҚАЗ', ru: 'РУС' };

/** Each language's own name for itself, shown where there is room for the whole word. */
export const LANGUAGE_NATIVE_NAMES: Record<Language, string> = { kk: 'Қазақша', ru: 'Русский' };
